<template>
	<div class="ol-sm-12 col-lg-2">
		<div class="filter__wrapper" :class="{open: 'rank' === showList, close: 'rank' !== showList}">
			<input type="text"
				   :placeholder="$t('filters.rank')"
				   class="filter"
				   :class="{open: 'rank' === showList, close: 'rank' !== showList}"
				   @click="updateShowList('rank')"
				   @input="showList = 'rank'"
				   v-model="searchByRank"
			>
			<ul v-show="'rank' === showList"
				class="filter__list"
			>
				<li class="filter__list-item" @click="removeRanks">{{$t('filters.remove')}}</li>
				<li v-for="item in rank.items"
					class="filter__list-item"
					:class="{'filter__list-item--active': $store.getters.isRankActive(item)}"
					@click="changeFilters(item)"
				>
					{{ item }}
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	import { mapActions, mapMutations } from 'vuex'

	export default {
		props: [
			'openFilters'
		],
		data () {
			return {
				showList: '',
				searchByRank: '',
				rank: {
					value: 'rank',
					items: ['national', 'international', 'club']
				}
			}
		},
		watch: {
			'$store.state.events.routeParams.rank' () {
				this.setRank()
			}
		},
		methods: {
			...mapActions(['fetchEvents']),
			...mapMutations(['addRank']),
			...mapMutations(['removeRank']),
			changeFilters (rank) {
				this.showList === rank
					? this.removeRank()
					: this.addRank(rank)

				this.fetchEvents()
				this.showList = ''
			},
			updateShowList (rank) {
				if (this.showList === rank) {
					this.showList = ''
				} else {
					setTimeout(() => {
						this.showList = rank
					}, 0)
				}
			},
			closeFlitersLists (e) {
				const open = document.querySelector('.open')
				if (open && !e.target.matches('.filter__list, .filter__list *')) {
					this.showList = ''
				}
			},
			setRank () {
				const rankItem = this.rank.items.find(rank => (
					rank === this.$store.state.events.routeParams.rank
				))
				if (rankItem === this.$store.state.events.activeRank) {
					return
				}
				this.addRank(rankItem || '')
				this.fetchEvents()
			},
			removeRanks () {
				this.removeRank()
				this.fetchEvents()
				this.showList = ''
			}
		},
		created () {
			window.addEventListener('click', this.closeFlitersLists)
			if (this.$route.query) {
				this.setRank()
			}
		},
		beforeDestroy () {
			window.removeEventListener('click', this.closeFlitersLists)
		}
	}
</script>

<style lang="scss" scoped>
	@import "../../../styles/variables.scss";
	@import "../../../styles/filters.scss";
</style>



// WEBPACK FOOTER //
// src/components/EventsList/Filters/RankFilterComponent.vue